export default "__VITE_ASSET__a8JNCgYF__"